import { AttachmentReference, AttachmentReferenceTypeEnum, Maybe } from '@vendorflow/types'
import { fetchAttachmentUsingGET } from 'apis/Filer.api'
import { useIdentities } from 'queries/Identities.queries'
import { useMemo } from 'react'
import { useChannel } from 'queries/Channels.queries'
import { IdentitiesRelated } from '@vendorflow/types/lib/types/Messages'
import { MessageWithContext } from 'types/Messages'
import { getAddRemoveMemberMessage } from 'pages/WorkspacePage/Workspace.service'

export async function getAttachmentHrefFromAttachmentReference(ref: AttachmentReference): Promise<string> {
  if (ref['@type'] == AttachmentReferenceTypeEnum.URI) {
    return ref.href
  } else {
    const { href } = await fetchAttachmentUsingGET(ref.id)
    return href
  }
}

export function useAddOrRemoveMemberText(message: Maybe<MessageWithContext>, action: 'joined' | 'left') {
  const ids = (message?.body as IdentitiesRelated)?.identities || []
  const identitiesById = useIdentities(ids)
  const identities = useMemo(
    () => ids.map((id) => (identitiesById.data || {})[id]).filter(Boolean),
    [identitiesById.dataUpdatedAt, identitiesById.data, ids]
  )
  const channel = useChannel(message?.channel)
  const channelType = useMemo(() => channel.data?.channel.channelType || null, [channel.dataUpdatedAt])

  if (!ids.length) {
    return ''
  }

  return identitiesById.isInitialLoading || channel.isInitialLoading
    ? 'Loading...'
    : getAddRemoveMemberMessage(identities, action, channelType)
}
